export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/c149c2995e67c98d8198109bf15793c7.svg";